import React, {useState} from 'react';
import {Checkbox, Flex, Td, Text, Tooltip, Kbd} from "@chakra-ui/react";
import VideoPlayerIcon from "../../assets/video-play.svg";
import {IProject} from "../../models/interfaces/project.interface.ts";
import {useProject} from "../../hooks/useProject.ts";
import platform from "platform";
import KeyCombo from "../KeyCombo.tsx";

interface ProjectTableFileColumnProps {
  project: IProject;
  selectedRows: string[];
  projectPercentage: number | null;
}

const ProjectTableFileColumn: React.FC<ProjectTableFileColumnProps> = (
  {
    project,
    selectedRows,
    projectPercentage
  }: ProjectTableFileColumnProps) => {
  const {getDateStringAtUtcFormat} = useProject();
  const formattedDate: string = getDateStringAtUtcFormat(project.updatedAt);

  const [isHovered, setIsHovered] = useState(false);

  const renderIcon = () => {
    if (selectedRows.includes(project.id)) {
      return (
        <Checkbox
          size="lg"
          isChecked={true}
          sx={{
            '&.chakra-checkbox[data-checked] .chakra-checkbox__control': {
              bg: 'brandPurple.500',
              borderColor: 'brandPurple.500',
              borderRadius: 'md',
            },
          }}
        />
      );
    }

    if (isHovered && projectPercentage === 100) {
      return <span><Kbd>⌘</Kbd></span>;
    }

    return <img src={VideoPlayerIcon} alt={project.name} width="25px"/>;
  };

  return (
    <Td
      textAlign="left"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Flex className="items-center gap-2 justify-start relative">
        {renderIcon()}
        {project.name.length > 25 ? (
          <Tooltip label={project.name} hasArrow>
            <Flex direction="column" maxW="200px">
              <Text noOfLines={1} isTruncated>
                {project.name.substring(0, 22) + "..."}
              </Text>
              <Text className="text-xs text-n-600 dark:text-n-400">{formattedDate}</Text>
            </Flex>
          </Tooltip>
        ) : (
          <Flex direction="column">
            <Text>{project.name}</Text>
            <Text className="text-xs text-n-600 dark:text-n-400">{formattedDate}</Text>
          </Flex>
        )}
      </Flex>
    </Td>
  );
};

export default ProjectTableFileColumn;